import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'escapeCode'
})
export class TextEscapeCodePipe implements PipeTransform {
  transform(value: string): string {
    function bodyEscaper(body: string, p1: string, p2: string, p3: string, p4: string): string {
      let repText: string;

      if (p1?.length > 0) {
        repText = p1;
      } else if (p2?.length > 0) {
        repText = p2;
      } else if (p3?.length > 0) {
        repText = p3;
      } else {
        repText = p4;
      }

      const str = repText
        .replace(/&/g, '&amp;')
        .replace(/'/g, '&apos;')
        .replace(/"/g, '&quot;')
        .replace(/\\/g, '\\\\')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/\u0000/g, '\\0');

      return body.replace(repText, str);
    }

    return value.replace(
      /\@\@ ([\s\S]+)<br \/>File:|\@\@ ([\s\S]+)<br>File:|\@\@ ([\s\S]+)<br \/><\/pre>|\@\@ ([\s\S]+)<br><\/pre>/g,
      bodyEscaper
    );
  }
}
